import { Config } from '../config/config.es6';
import Top from '../models/top.es6';
import TopView from '../views/topView.es6';

export default class TopController {
    constructor() {
        this.top = new Top();
        this.topView = new TopView();

        this.achevementCount = 0;

        this._init();
    }

    _init() {
        this._initDisplay();
        this._handleTap();

        // 定期的にAPIを呼び出すメソッド
        this._startAutoUpdate();
    }

    // タップカウントの取得と初期化
    async _initDisplay() {
        await this._updateDisplay();
        this._handleStart();
    }

    async _updateDisplay() {
        // 取得
        const tapCount = await this.top.getAPI();
        console.log('tapCount', tapCount);

        // 2つの目標のうちどこまで達成したか判別して書き込む
        this.achevementCount = this.top.getAchevementCount(tapCount);
        this.topView.setAchievementCount(this.achevementCount);

        // メインカウンターに表示する数を計算
        const mainCount = this.top.getMainCount(tapCount, this.achevementCount);

        // カウンターの数字を書き込む
        this.topView.displayCount(tapCount, Config.TOTAL_COUNT.DIGIT, this.topView.totalCountDisplay);
        this.topView.displayCount(mainCount, Config.MAIN_COUNT.DIGIT, this.topView.mainCountDisplay);

        // リワードボタンをアクティブ化
        this.topView.rewardBtns.forEach((elm) => {
            const isActiveReward = this.top.isActiveReward(elm.getAttribute('data-reward'), this.achevementCount);
            this.topView.activeRewardBtns(elm, isActiveReward);
        });

        // リワードモーダルのコンテンツを挿入
        const rewardModals = this.topView.rewardModals;
        for (let i = 0; i < 1 && i < rewardModals.length; i++) {
            const elm = rewardModals[i];
            const rewardPath = this.top.getRewardPath(elm.getAttribute('data-reward'));
            const isActiveReward = this.top.isActiveReward(elm.getAttribute('data-reward'), this.achevementCount);
            this.topView.insertActiveReward(elm, isActiveReward, rewardPath);
        }

        // 2つ目のリワードボタンの特別な処理
        const isActiveRewardForYoutube = this.top.isActiveReward('2', this.achevementCount);
        this.topView.insertYoutubeID(isActiveRewardForYoutube, Config.REWARD_DIR['2']); // 必要に応じてYouTubeの動画IDを変更

        // ローディング解除
        this.topView.setPageReady();
    }

    _startAutoUpdate() {
        setInterval(async () => {
            await this._updateDisplay();
        }, Config.AUTO_UPDATE_INTERVAL);
    }

    _handleStart() {
        if (this.achevementCount === Config.ACHIVEMENT_COUNT.length) {
            this.topView.startBtn.addEventListener('click', () => this.topView.show10000Achivement());
        }
    }

    _handleTap() {
        this.topView.tapBtn.addEventListener('click', this._processTap.bind(this));
    }

    async _processTap() {
        // アニメーション
        this.topView.tapAnimation(this.achevementCount);

        // 送信
        await this.top.sendAPI(Config.MAIN_COUNT.INCREMENT);
    }
}
